import styled from "styled-components";

export const StyledRecipes = styled.div`
    .empty-state,
    .loading-state,
    .error-state {
        text-align: center;
        padding: 2rem;
        color: var(--color-text-secondary);
    }

    .error-state {
        color: var(--color-danger);
    }

    .recipe-link {
        text-decoration: none;
    }

    .secondary {
        padding: 5px 10px;
        margin-bottom: 0;
    }

    @media (max-width: 480px) {
        .recipe-actions {
            padding: 0 0.75rem 0.75rem 0.75rem;
        }
    }

    .btn_addToWishlist {
        width: fit-content;
    }
`;
